import FieldReportingDashboardStore from "./Dashboard/FieldReportingDashboard.Store";
import HardwareTrackingStore from "./HardwareTracking/HardwareTracking.Store";
import PanelTrackingStore from "./PanelTracking/PanelTracking.Store";
import FieldActivityIssuesViewStore from "./Dashboard/FieldActivityIssues.Store";
import JobFieldReportingDashboardStore from "./JobFieldReporting/JobFieldReportingDashboard.Store";

const fieldReportingStoresList = [
  { name: "fieldReportingDashboardStore", store: FieldReportingDashboardStore },
  { name: "hardwareTrackingStore", store: HardwareTrackingStore },
  { name: "panelTrackingStore", store: PanelTrackingStore },
  { name: "fieldActivityIssuesViewStore", store: FieldActivityIssuesViewStore },
  { name: "jobFieldReportingDashboardStore", store: JobFieldReportingDashboardStore },
];

export default fieldReportingStoresList;
